










import { Vue, Component } from 'vue-property-decorator'
import { TEXTOS_DA_TROCA } from './textos-da-troca'

/**
 * Alerta fixo da tela clássica depois da virada, quando a pessoa a escolheu de propósito. Não fecha e não tem botão: a
 * troca fica só no botão da barra, para não haver dois controles com visuais diferentes.
 */
@Component
export default class AvisoDaTelaClassica extends Vue {
	TEXTOS = TEXTOS_DA_TROCA.avisoDaClassica
}
